import { render, staticRenderFns } from "./ACheckbox.vue?vue&type=template&id=172134a7"
import script from "./ACheckbox.vue?vue&type=script&lang=js"
export * from "./ACheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports